import React from 'react'
import type { LotStoryArtifactVersionV1 } from '../../types/lotStory'
import type { TranslateFn } from './lotStoryLibraryTypes'
import {
  buildStoryVersionCompareRows,
  type LotStoryLibraryPresentation
} from './lotStoryPresentation'

type LotStoryLibraryCompareDiffTableProps = {
  t: TranslateFn
  compareBaseStoryVersion: LotStoryArtifactVersionV1
  compareTargetStoryVersion: LotStoryArtifactVersionV1
  presentation: LotStoryLibraryPresentation
}

export default function LotStoryLibraryCompareDiffTable({
  t,
  compareBaseStoryVersion,
  compareTargetStoryVersion,
  presentation
}: Readonly<LotStoryLibraryCompareDiffTableProps>) {
  const {
    formatHistoryTimestamp,
    storyPresentation
  } = presentation
  const storyVersionCompareRows = buildStoryVersionCompareRows({
    t,
    compareBaseStoryVersion,
    compareTargetStoryVersion,
    formatHistoryTimestamp,
    storyPresentation
  })

  return (
    <div style={{ display: 'grid', gap: 8 }}>
      <div style={{ display: 'grid', gap: 8, gridTemplateColumns: 'minmax(140px, 220px) minmax(0, 1fr) minmax(0, 1fr)', fontSize: 12, fontWeight: 700, color: '#1d4ed8' }}>
        <div />
        <div>{t('lots.story.library.compare.currentColumn', { version: compareBaseStoryVersion.versionNumber })}</div>
        <div>{t('lots.story.library.compare.comparedColumn', { version: compareTargetStoryVersion.versionNumber })}</div>
      </div>

      {storyVersionCompareRows.length === 0 ? (
        <div style={{ fontSize: 13, color: '#475569' }}>{t('lots.story.library.compare.empty')}</div>
      ) : (
        storyVersionCompareRows.map((row) => (
          <div key={row.labelKey} style={{ display: 'grid', gap: 8, gridTemplateColumns: 'minmax(140px, 220px) minmax(0, 1fr) minmax(0, 1fr)', alignItems: 'start', borderTop: '1px solid #dbeafe', paddingTop: 8 }}>
            <strong style={{ fontSize: 12, color: '#92400e' }}>{t(row.labelKey)}</strong>
            <div style={{ fontSize: 13, color: '#111827' }}>{row.currentValue}</div>
            <div style={{ fontSize: 13, color: '#1d4ed8' }}>{row.comparedValue}</div>
          </div>
        ))
      )}
    </div>
  )
}